/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {getRoutePageComponent, getContextRoutePageComponent} from '../common/controller/route-page-component-registry';
import {collectStatesFromProvider, AdnRouterHelperApi} from '../routing/state-utils';
import {adminResourceItemRouteResolve} from '../common/controller/admin-resource-routing';
import {AdminResourceContextRoutePageComponent} from '../common/controller/admin-resource-context-route-page.component';
import {AdminResourceItemRoutePageComponent} from '../common/controller/admin-resource-item-route-page.component';
import _ from 'lodash';
import {ThirdPartyAudienceResource} from '../../components/api/resources/resource/third-party-audience.resource';



export function thirdPartyAudienceStates(adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  return collectStatesFromProvider(function register($stateProvider, adnRouterHelperProvider) {
const rh = adnRouterHelperProvider.$get().createRouterHelper('third-party-audiences.third-party-audience', ThirdPartyAudienceResource, 'app.adv', 'app');
        const readOnlyResolve = /*@ngInject*/ function() {
          const LocalUserPermissions = adnRouterHelper.services.localUserPermissions();

          return !LocalUserPermissions.hasNetwork('MANAGE_SYSTEM') && !LocalUserPermissions.hasAny('MANAGE_AUDIENCES');
        };
        $stateProvider.state(rh.listPath(), rh.list({
          views: {
            'content@app': { component: getRoutePageComponent('third-party-audience-route') }
          },
          resolve: {
            readOnly: readOnlyResolve
          }
        }))
          .state(rh.newItemPath(), rh.newItem())
          .state(rh.itemPath(), rh.modelCommsItem({
            resolve: _.merge({}, adminResourceItemRouteResolve('third-party-audience-item', 'item'), {
              readOnly: readOnlyResolve
            }),
            views: {
              'content@app': {
                component: AdminResourceItemRoutePageComponent,
                bindings: {item: 'adminResourceItemKey', variant: 'adminResourceItemVariant'}
              },
              'context@app': {component: AdminResourceContextRoutePageComponent}
            }
          }, 'ThirdPartyAudience'));
  }, adnRouterHelper);
}
